export default {
	"waterVideos": [
		'videos/water/dscf8773_1.mov',
		'videos/water/dscf8803_1.mov',
		'videos/water/dscf8804_1.mov',
		'videos/water/dscf9911_1.mov',
		'videos/water/img_0551.mov',
		'videos/water/img_0563.mov',
		'videos/water/img_0564.mov',
		'videos/water/img_0800.mov',
		'videos/water/img_1190.mov',
		'videos/water/img_1846.mov',
		'videos/water/img_2373_1.mov',
		'videos/water/img_2376_1.mov',
		'videos/water/img_2376_2.mov',
		'videos/water/img_2377_1.mov',
		'videos/water/img_2378_1.mov',
		'videos/water/img_4231.mov',
		'videos/water/img_6225.mov',
		'videos/water/img_8721.mov',
		'videos/water/img_9372.mov',
		'videos/water/mvi_2791_1.mov',
		'videos/water/mvi_3446_1.mov',
		'videos/water/mvi_3446_2.mov',
		'videos/water/mvi_3446_3.mov',
		'videos/water/mvi_3447_1.mov',
		'videos/water/mvi_3448_1.mov',
		'videos/water/mvi_3449_1.mov',
		'videos/water/mvi_4621_1.mov',
		'videos/water/mvi_4621_2.mov',
		'videos/water/mvi_4622_1.mov',
		'videos/water/mvi_4623_1.mov',
		'videos/water/mvi_4625_1.mov',
		'videos/water/mvi_5230_1.mov',
		'videos/water/mvi_5276_1.mov',
		'videos/water/mvi_5277_1.mov',
		'videos/water/mvi_5278_1.mov'
	],

	//Tous les messages en français
	"fr": {

		//meta tags
		"meta": {
			"description": "Une curieuse aventure qui traverse les murs. Une production de l'ONF créée par AATOAA (Vincent Morisset, Édouard Lanctôt-Benoit, Caroline Robert) et Sean Michaels.",
			"keywords": "ONF, NFB, AATOAA, Motto, Septembre, interactif, roman, book, fiction, participatif, mobile, film, video",
			"url": "https://www.motto.io/fr",	
			"alturl": "https://www.motto.io",

			"share_meta_line1": "Motto - Une curieuse aventure qui traverse les murs. Produit par l’ONF et créé par AATOAA.",
			"share_meta_line2": "",
			"twitter_meta_line1": "Motto – Une curieuse aventure qui traverse les murs",
			"twitter_meta_line2": "Produit par l’ONF et créé par AATOAA. En six chapitres sur mobile.",
			//"share_meta_line1": "Motto – Une curieuse aventure qui traverse les murs",
			//"share_meta_line2": "Produit par l’ONF et créé par AATOAA. En six chapitres sur mobile.",
			//"share_meta_line1": "Motto, une curieuse aventure qui traverse les murs",
			//"share_meta_line2": "Produit par l’ONF et créé par AATOAA.",
			
			"share_twitter": "Découvrez Motto, une incroyable histoire de fantôme qui prend forme grâce à votre manière unique de voir le monde. Explorez les six chapitres maintenant. #mottoio🏺",
			"share_others": "Une curieuse aventure qui traverse les murs. À découvrir gratuitement sur mobile."
		},

		//FR: Menu et chapitres
		"menu": {
			"allchapters": "Tous les chapitres",
			"restartmotto": "Recommencer Motto",
			"reset": `Ceci réinitialisera Motto<br>et te permettra d’enregistrer<br>de nouvelles vidéos.`,
			"chapter1": "Motto",
			"in2": "Étoile déchue",
			"in2_alt": "Chaises du monde",
			"out2": "De si jolies ordures",
			"chapter3": "Drôles d'amis",
			"chapter4": "Pain au levain",
			"chapter5": "Dans la tête<br>de Septembre",
			"chapter5_alt": "Septembre",
			"chapter6": "Tous les saxophones"
		},

		//FR: Système
		"system": {
			"loading": "Chargement",
			"orientationwarning": "Désolé, Motto fonctionne seulement<br>à la verticale (mode portait)!",
		},

		//FR: Messages d'erreur
		"errors": {
			"desktop": {
				"text": `
					<span style=\"color:#000000; font-size:0.2em\"><br><br></span>
					<span style=\"color:#000000; font-size:2.2em\">&nbsp;M O T T O&nbsp;</span>
					<span style=\"color:#000000; font-size:0.2em\"><br></span>
					<span style=\"color:#000000; font-size:0.8em\">Une curieuse aventure<br>qui traverse les murs.</span>
					<span style=\"color:#000000; font-size:0.2em\"><br><br></span>
					<span style=\"color:#000000; font-size:0.6em\">_____________________________________</span>
					<span style=\"color:#000000; font-size:0.2em\"><br><br><br></span>
					<span style=\"color:#000000; font-size:0.6em\">
					Bonjour! Motto ne peut être utilisé<br>
					sur {device}. Veuillez consulter<br>
					motto.io sur votre téléphone<br>
					et nous pourrons nous lancer.
					</span>
					<span style=\"color:#000000; font-size:0.3em\"><br><br><br></span>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"desktop": "un ordinateur",
				"tablet": "une tablette"
			},
			"loading": {
				"text": `
					<br>Quelque chose ne<br>tourne pas rond.<br>
					Vérifiez votre connexion<br>ou essayez plus tard.<br>
					On vous attendra, promis!<br><br>
				`,
				"textSize": "1.1em",
				"background": "white"
			},
			"webgl": {
				"text": `
					<br><span style=\"; font-size:2.2em\">&nbsp;M O T T O&nbsp;</span>
					<br>__________________<br><br>
					Toutes nos excuses :<br>
					nous n’avons pas trouvé<br>
					le moyen de faire fonctionner<br>
					Motto sur cet appareil.<br><br>
					Le capitalisme est une plaie,<br>
					mais nous espérons que<br>
					vous essaierez sur un<br>
					appareil plus récent.<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
			},
			"browser": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Bonjour! Malheureusement,<br>
					Motto requiert un<br>
					navigateur plus récent.<br><br>
					Veuillez mettre à jour<br>
					votre logiciel et<br>
					recharger cette page pour<br>
					que nous puissions<br>
					partir à l’aventure.<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"device": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Toutes nos excuses : nous n’avons pas trouvé le moyen de faire fonctionner Motto sur cet appareil. Le capitalisme est une plaie, mais nous espérons que vous essaierez sur un appareil plus récent.<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"safari": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Bonjour ! Malheureusement, Motto fonctionne uniquement dans {browser}. Vous n'avez qu'à changer de navigateur et écrire :<br>motto.io<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"safari_inapp": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Salut! Motto est une<br>expérience conçue pour votre navigateur.<br>Pour continuer, veuillez démarrer {browser} et écrire :<br>motto.io<br><br>
					<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			}
		},

		//FR: Messages de caméra
		"camera": {
			"refusedReload": `
				Milles excuses, mais tu ne peux pas continuer sur Motto à moins de lui donner accès à ta caméra. Nous ne soumettrons pas tes vidéos sans permission, et aucun audio ne sera enregistré.<br><br>
				<a href=\"#\" id=\"page-reload\">Rafraîchis la page pour continuer.</a>
			`,
			"refusedIos":`
				Pour continuer, tu dois permettre à MOTTO d’accéder à ta caméra. Si tu vois cette page, c’est soit parce que tu ne veux vraiment pas poursuivre ce projet, soit parce que ta caméra est désactivée dans les paramètres de ton navigateur. Pour y remédier, va dans Paramètres &gt; {browser} &gt; Accès caméra et microphone et Activer.<br><br>
				<a href=\"#\" id=\"page-reload\">Puis, rafraichis la page</a>
			`,
			"refusedAndroid":`
				Pour continuer, tu dois permettre à MOTTO d’accéder à ta caméra en changeant les paramètres de site de Chrome pour cette page. Tu peux le faire en cliquant sur l’icône de cadenas en haut de la page, en choisissant paramètres du site et en autorisant l’accès à la caméra. Nous ne soumettrons pas tes vidéos sans permission, et aucun audio ne sera enregistré.</br><br>
				<a href=\"#\" id=\"page-reload\">Puis, rafraichis la page</a>
			`,
			"refusedOthers":`
				Pour continuer, tu dois permettre à MOTTO d’accéder à ta caméra. Si tu vois cette page, c’est soit parce que tu ne veux vraiment pas poursuivre ce projet, soit parce que ta caméra est désactivée dans les paramètres de ton navigateur. Pour y remédier, va dans Paramètres &gt; {browser} &gt;, Accès caméra et microphone et Activer. Nous ne soumettrons pas tes vidéos sans permission, et aucun audio ne sera enregistré.</br><br>
				<a href=\"#\" id=\"page-reload\">Puis, rafraichis la page</a>
			`,
			"working": "La caméra fonctionne, super!"
		},

		//FR: views
		"views": {
			"welcomeBack": {
				"text": `
					<a id=\"link_continue_now\"><br><span style=\"; font-size:0.6em\">M O T T O
					<br><br>__________________</span><br><br>
					<span style=\"color:#000000; font-size:0.2em\"></span>
					Ça fait plaisir<br>de te revoir!</span>
					<br><br>&nbsp;&nbsp;Continue là où&nbsp;&nbsp;<br>tu t'es arrêté.<br><br></a>
				`,
				"textType": "center",
				"textSize": "1.1em",
				"type": "montage",
				"isWelcomeBack": true,
				"params": {
					"montage": ["videos/bookmark/book_close.mov"],
					"palindrome": true, 
					"reverse": true,
					"videoDuration": 3.0,
					"videoSpeed": 1.0
				},
				"background": "white"
			},
			"continueLater": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				</span>Nous marquons ta place<br>pour que tu puisses<br>finir plus tard.<br>Tu peux également<br>ajouter cette page<br>sur ton écran d'accueil<br>si tu le veux. À bientôt!
				<span style=\"font-size:0.6em\"><br><br>(Note : si ton navigateur est en mode Privé/Incognito, tu dois laisser la page ouverte pour ne pas perdre ta place.)<br><br>
				</span>
			`,
			"continueLaterReturnCovid": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Chapitre<br>suivant</a><br><br>
			`,
			"continueLaterReturnGhost5": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Conclure<br>maintenant</a><br><br>
			`,
			"continueLaterReturn4": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Continuer<br>&nbsp;à l'intérieur&nbsp;<br>d'un fantôme</a><br><br>
			`,
			"continueLaterReturn": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Continuer<br>&nbsp;à l'intérieur&nbsp;</a><br><br>
				<span style=\"color:777777; font-size:0.6em\">-</span><br><br>
				<a id=\"link_out_next\">Continuer<br>à l'extérieur</a><br><br>
			`,
			"continueLaterMontage":{
				"montage": ["videos/bookmark/book_open.mov"],
				"palindrome": true, 
				"reverse": true,
				"videoDuration": 3.0,
				"videoSpeed": 0.8
			},
			"allowCameraFirst": {
				"text": `<span>En cliquant sur « Autoriser »,<br>vous permettez à Motto d’utiliser les vidéos que vous soumettez dans le cadre du projet. Aucun son ne sera enregistré et nous ne transmettrons ces images à personne d’autre.</span>`,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraChapter": {
				"text": `Nous devons réautoriser ta<br>caméra pour ce chapitre.`,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraReturn": {
				"text": `Ça fait plaisir de te revoir!<br>Clique sur « Autoriser » pour pouvoir continuer à utiliser ta caméra. Nous n’enregistrerons jamais de son.`,
				"isAutomaticReturn": true,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraReturnNoWelcomeBack": {
				"text": `Clique sur « Autoriser » pour pouvoir continuer à utiliser ta caméra. Nous n’enregistrerons jamais de son.`,
				"isAutomaticReturn": true,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			}
		},


		//
		// FR: Les textes de page
		//
		"pages": {
			"about-title": "À propos",
			"share-title": "Partager Motto",
			"credits-title": "Crédits",
			"about": `
				<div class="about-credits">
					Réalisation : <a target="_BLANK" href="https://vincentmorisset.com/" class="about-name-link"><b>Vincent Morisset</b></a><br>
					Texte : <a target="_BLANK" href="http://byseanmichaels.com/" class="about-name-link"><b>Sean Michaels</b></a><br>
					Code : <a target="_BLANK" href="https://edouardlb.com/" class="about-name-link"><b>Édouard Lanctôt-Benoit</b></a><br>
					Montage : <a target="_BLANK" href="https://caroline-robert.com/" class="about-name-link"><b>Caroline Robert</b></a><br>
					Création : <a target="_BLANK" href="http://aatoaa.com/" class="about-name-link"><b>studio AATOAA</b></a><br>
					Production : <a target="_BLANK" href="https://nfb.ca/" class="about-name-link"><b>Office national du film du Canada</b></a><br><br>
					<a target="_BLANK" class="about-link" onclick="if (window.MenuController) {window.MenuController.openCredits();}">Tous les crédits</a><br>
					<br>
				</div>
				<div class="text-spacer-line"></div>
				<br>
				Motto est une aventure extraordinaire et unique en son genre. Ce livre interactif, composé de milliers de petites vidéos, raconte le parcours millénaire d’un sympathique esprit nommé Septembre. À mi-chemin entre une histoire de fantôme et une chasse au trésor, Motto oscille entre le documentaire et la fiction, tissant les images créées par chaque participant dans la trame émotive de son récit. L’oeuvre agit comme un prisme qui, par les multiples réfractions de l’imaginaire de tous les utilisateurs, transforme continuellement leur perception du monde.<br><br>Conçu pour votre appareil mobile, assez petit pour se glisser dans votre poche, Motto allie les nouvelles technologies aux plus anciennes. Texte, image, algorithme et vision par ordinateur s’entremêlent alors qu’un narrateur sans nom vous conduit d’aujourd’hui à hier, vers un éventuel demain, passant de la forêt québécoise au désert chilien et aux rives animées du Nil. Septembre manque à l’appel : mais où ce fantôme est-il passé ? Que vous apprend cette quête ? En méditant sur la mémoire, les métaphores et le pouvoir de la créativité — et en sollicitant chacun des sens de ses utilisateurs —, Motto fait naître son propre univers, fascinant et intime, dans lequel vous ne devinerez jamais ce qui va se produire.<br><br>Motto est une collaboration originale entre AATOAA, le réputé studio de création numérique de Vincent Morisset, et le romancier primé Sean Michaels. L’Office national du film du Canada et Morisset font équipe pour une troisième fois après BLA BLA (2011) et Jusqu’ici (2015), deux œuvres couronnées d’un prix Webby. L’équipe de création explore cette fois-ci un tout nouveau vocabulaire narratif en invitant les utilisateurs à présenter des fragments de leur univers sous la forme d’une histoire. Motto puise dans des influences aussi diverses qu’Agnès Varda, Snapchat, Italo Calvino, Christian Marclay, W. G. Sebald, Bruno Munari et le film Dans la peau de John Malkovich.<br>
				<div class="text-spacer-line"></div>
				<br>
				<a target="_BLANK" class="about-link" href="https://espacemedia.onf.ca/epk/motto/">Lien vers le kit de presse</a><br>
				<br>
				<div class="text-spacer-line"></div>
				<br>
				<b>
				Informations légales</b><br><br>
				Motto utilise des témoins (cookies) pour permettre certaines fonctionnalités à l’expérience. Les témoins sont de petits fichiers sauvegardés sur votre appareil lorsque vous accédez à certains sites Web. Comme Motto est une œuvre en six chapitres, vous n’en ferez peut-être pas l’expérience en une seule fois. Les témoins vous permettent de vivre Motto en plusieurs séances, sans perdre le fil de votre progression et en préservant vos contributions vidéo pour qu’elles vous réapparaissent au cours de l’expérience. Notez qu’aucune donnée personnelle n’est récoltée au cours de l’expérience. Si vous ne voulez pas qu’un témoin soit inscrit sur votre ordinateur par le site de l’ONF, vous pouvez désactiver la fonction de stockage des témoins de votre navigateur. Toutefois, votre progression dans Motto ne sera pas sauvegardée, et vous perdrez toute trace de vos contributions d’une séance à l’autre en fermant la fenêtre de Motto dans votre fureteur Web.
				<br><br>
				Motto utilise des milliers de petites vidéos créées par les participants. En autorisant Motto à utiliser la fonctionnalité de votre caméra, vous concédez à l’ONF les droits d’utiliser les images que vous capterez en vivant l’expérience. Ces images seront utilisées exclusivement dans le projet Motto, ses déclinaisons, ainsi que tout usage promotionnel lié à l’oeuvre.<br><br>
			`,
			"credits": `
				Une création du studio <a target="_BLANK" href="http://aatoaa.com/" class="about-name-link"><b>AATOAA</b></a><br>
				<br>
				Une production de <a target="_BLANK" href="https://nfb.ca/" class="about-name-link"><b>l'Office national du film du Canada</b></a><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Réalisation<br>
				<a target="_BLANK" href="https://vincentmorisset.com/" class="about-name-link"><b>Vincent Morisset</b></a><br>
				<br>
				Texte<br>
				<a target="_BLANK" href="http://byseanmichaels.com/" class="about-name-link"><b>Sean Michaels</b></a><br>
				<br>
				Code<br>
				<a target="_BLANK" href="https://edouardlb.com/" class="about-name-link"><b>Édouard Lanctôt-Benoit</b></a><br>
				<br>
				Montage<br>
				<a target="_BLANK" href="https://caroline-robert.com/" class="about-name-link"><b>Caroline Robert</b></a><br>
				<br>
				Tournages<br>
				<b>Caroline Robert & Vincent Morisset</b><br>
				<br>
				Adaptation en français<br>
				<b>Catherine Leroux</b><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Office national du film du Canada :<br><br>
				Productrice<br>
				<b>Marie-Pier Gauthier</b><br>
				<br>
				Producteurs exécutifs<br>
				<b>Louis-Richard Tremblay</b><br>
				<b>Hugues Sweeney</b><br>
				<br>
				Chargée de production<br>
				<b>Marie-Eve Babineau</b><br>
				<br>
				Directeur des technologies<br>
				<b>Martin Viau</b><br>
				<br>
				Chargées d'édition<br>
				<b>Valérie Darveau</b><br>
				<b>Laurence Dolbec</b><br>
				<br>
				Coordonnatrice principale de production<br>
				<b>Léa Graziella Formigli</b><br>
				<br>
				Coordonnatrice médias interactifs<br>
				<b>Caroline Fournier</b><br>
				<br>
				Administratrice<br>
				<b>Marie-Andrée Bonneau</b><br>
				<br>
				Coordonnatrice principale administrative<br>
				<b>Claudia Boutin</b><br>
				<br>
				Coordonnatrice de production<br>
				<b>Dominique Brunet</b><br>
				<br>
				Technologies de l'information<br>
				<b>Sergiu Suciu</b><br>
				<br>
				Agente marketing<br>
				<b>Laurianne Desormiers</b> <br>
				<br>
				Coordonnatrice à la mise en marché<br>
				<b>Stéphanie Quevillon</b><br>
				<br>
				Stratèges médias sociaux<br>
				<b>Emilie Nguyen Ngoc</b><br>
				<b>Hannah Martin</b><br>
				<br>
				Gestionnaires de communautés<br>
				<b>Alyssia Duval-Nguon</b><br>
				<b>Melissa Sauvé</b><br>
				<br>
				Relations de presse<br>
				<b>Nadine Viau</b><br>
				<b>Jennifer Mair</b><br>
				<br>
				Services juridiques<br>
				<b>Christian Pitchen</b><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Collaborateurs :<br><br>
				Fixeur (tournage Chili)<br>
				<b>Pablo Esquer</b><br>
				<br>
				Recherchiste<br>
				<b>Fadwa Lapierre</b><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Archives :<br><br>
				<b>Aaron Morris<br>
				Albert Courtemanche &  Bibliothèque et Archives nationales du Québec<br>
				Caroline Robert & Vincent Morisset<br>
				Conrad Poirier & Bibliothèque et Archives nationales du Québec<br>
				Justin Bilton via Storyful<br>
				Metropolitain Museum of Art<br>
				Programme Apollo, NASA<br>
				Wikimedia Commons<br></b>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Premières contributions :<br><br>
				<b>Aaron Varquero<br>
				Aimée Kassi<br>
				Alexe Louisa<br>
				Angel Carpio<br>
				Anne-Marie Lavigne<br>
				Astrid Feringa<br>
				Aymane Sahrane<br>
				Benedicte Kurzen<br>
				Camille Foisy<br>
				Carl Ruttan<br>
				Chilandre Patry<br>
				Deborah Chèrenfant<br>
				Diana Aziz<br>
				Diderik Evers<br>
				Dorothy Alexandre<br>
				Éricka Alnéus<br>
				Erwin Verbruggen<br>
				Eva van Dijk<br>
				Ewelyn Wnek<br>
				Fanny Robert<br>
				Francois Turcotte<br>
				Gígja Reynisdóttir<br>
				Greta Petronio<br>
				Guillaume Lee-Millier<br>
				Hamza Abouelouafaa<br>
				Harm Croockewit<br>
				Inge Bongers<br>
				Israel Hernandez Ruiz Velasco<br> 
				Jean-Michel Portail<br>
				Jean-Philippe Côté<br>
				Jessie Dorélien<br>
				Jessy Thermil<br>
				JF Nadeau<br>
				Jorge Camarotti<br>
				Jumoke Sanwo<br>
				Kevin Plasman<br>
				Leisa Lee<br>
				Lily Tremblay-Viau<br>
				Lyne Godin<br>
				Marianne Bourdages<br>
				Marisol de Santis<br>
				Matteo Frescobaldi<br>
				Nancy Thibodeau<br>
				Nicholas Klassen<br>
				Nicolas Ouellet<br>
				Nizar Lachqar<br>
				Pascale Daigle<br>
				Pascale Tetrault<br>
				Perry-Delphine Séraphin<br>
				Peter Antoine<br>
				PM Fortin<br>
				Quirine Racké<br>
				Rachid Sahrane<br>
				Rafaella Wang<br>
				Ravenne Portail<br>
				Rosalie Léonard<br>
				Sabrina Lachqar<br>
				Samantha Pietro<br>
				Sanne De Wilde<br>
				Sarah Spring<br>
				Sophia Jasmin<br>
				Sophie Robert<br>
				Soumia Sahrane<br>
				Stephane Buellet<br>
				Stephane Lafleur<br>
				Stevens Charles<br>
				Tawan Arun<br>
				Tracy Maurice<br>
				Yazmin Solorzano<br>
				Ying Gao</b><br><br>
				<div class="credits-spacer-small"></div>
				<br>
				Remerciements :<br><br>
				<b>Andrea Costabal<br>
				Arlen et Jan Michaels<br>
				Casadel Films<br>
				Caspar Sonnen<br>
				Catherine Emmanuel Brunet<br>
				Claudette Raymond<br>
				Daniela Ábrigo<br>
				Emily Wood<br>
				Gabi<br>
				IDFA Doclab<br>
				Jessie Van Vreden<br>
				La famille Morisset<br>
				La famille Pereda<br>
				La famille Robert<br>
				Le réseau public de la petite enfance<br>
				Lily Jeanne Babineau<br>
				Marcela Cavallaro<br>
				Marisol Bacunan<br>
				Martin Babineau<br>
				Musée canadien de la nature<br>
				Neues Museum<br>
				Raul Titerman<br>
				Rolando Santana<br>
				Sandro Perri<br>
				Sylvain Mazas<br>
				Thea Metcalfe et Miro<br>
				Thierry Sirois</b><br><br>
			`,
			"share": `
				<div class="share-large">
					<div class="share-btn" id="share-facebook">
						<div id="facebook-logo"></div>
						<div class="share-text">Facebook</div>
					</div>
				</div>
				<div class="share-large">
					<div class="share-btn" id="share-twitter">
						<div id="twitter-logo"></div>
						<div class="share-text">Twitter</div>
					</div>
				</div>
				<div class="share-large" id="share-link-container">
					<div class="share-btn" id="share-btn-link">
						<div id="sharelink-logo" id="share-link"></div>
						<div class="share-text">Copier le lien</div>
					</div>
				</div>
			`,
		}
	},

	//Tous les messages en anglais
	"en": {

		//meta tags
		"meta": {
			"description": "A curious adventure that reaches through walls. A NFB production, created by AATOAA (Vincent Morisset, Édouard Lanctôt-Benoit, Caroline Robert) and Sean Michaels.",
			"keywords": "ONF, NFB, AATOAA, Motto, September, interactive, novel, book, fiction, mobile, crowdsourced, video, film",
			"url": "https://www.motto.io",	
			"alturl": "https://www.motto.io/fr",

			"share_meta_line1": "Motto – A curious adventure that reaches through walls. A NFB production, created by AATOAA.",
			"share_meta_line2": "",
			//"share_meta_line1": "Motto – A curious adventure that reaches through walls",
			//"share_meta_line2": "A NFB production, created by AATOAA. In 6 chapters on your phone.",
			//"share_meta_line1": "A curious adventure that reaches through walls",
			//"share_meta_line2": "A NFB production, created by AATOAA.",

			"twitter_meta_line1": "Motto – A curious adventure that reaches through walls",
			"twitter_meta_line2": "A NFB production, created by AATOAA. In 6 chapters on your phone.",

			"share_twitter": "Come discover Motto, a playful ghost story brought to life by the one-of-a-kind way you see the world. Explore all six chapters now. #mottoio🏺",
			"share_others": "A curious adventure that reaches through walls. Explore all six chapters for free on your phone."
		},
		
		//EN: Menu et chapitres
		"menu": {
			"allchapters": "All Chapters",
			"restartmotto": "Restart Motto",
			"reset": `This will reset Motto<br>to the beginning and<br>allow you to record<br>new videos.`,
			"chapter1": "Motto",
			"in2": "Fallen Star",
			"in2_alt": "Chairs of the World",
			"out2": "Such Nice Garbage",
			"chapter3": "Unusual Friends",
			"chapter4": "Sourdough",
			"chapter5": "The Mind of September",
			"chapter5_alt": "The Mind of September",
			"chapter6": "All Saxophones"
		},

		//En: Système
		"system": {
			"loading": "Loading",
			"orientationwarning": "Sorry, Motto only works<br>in vertical (portrait) mode!",
		},

		//EN: messages d'erreur
		"errors": {
			"desktop": {
				"text": `
					<span style=\"color:#000000; font-size:0.2em\"><br><br>
					</span><span style=\"color:#000000; font-size:2.2em\">&nbsp;M O T T O&nbsp;</span>
					<span style=\"color:#000000; font-size:0.2em\"><br></span>
					<span style=\"color:#000000; font-size:0.8em\">A curious adventure that<br>reaches through walls.</span>
					<span style=\"color:#000000; font-size:0.2em\"><br><br></span>
					<span style=\"color:#000000; font-size:0.6em\">_____________________________________</span>
					<span style=\"color:#000000; font-size:0.2em\"><br><br><br></span>
					<span style=\"color:#000000; font-size:0.6em">
					Hi! You can't experience Motto<br>
					on {device}. Please visit<br>
					motto.io on your phone<br>
					and we can get started together.
					</span>
					<span style=\"color:#000000; font-size:0.3em\"><br><br><br></span>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"desktop": "desktop",
				"tablet": "a tablet"
			},
			"loading": {
				"text": `
					<br>Something's wrong.<br>
					Check your connection<br>
					or try again later&mdash;<br>
					I promise I'll wait<br>for you!<br><br>
				`,
				"textSize": "1.1em",
				"background": "white"
			},
			"webgl": {
				"text": `
				<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Sorry&mdash;we couldn't find<br>
					a way to make Motto<br>work on this device.<br><br>
					Capitalism is the worst,<br>but we hope you will<br>
					try again on a newer<br>machine.
					<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
			},
			"browser": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Hi! Unfortunately,<br>
					Motto requires a<br>
					more recent browser.<br><br>
					Try updating your<br>
					software and reloading<br>
					this page so we can<br>
					go exploring.<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"device": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Sorry&mdash;we couldn't find<br>a way to make Motto<br>
					work on this device.<br>
					Capitalism is the worst,<br>
					but we hope you will<br>
					try again on a newer<br>
					machine.<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"safari": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Hi! Unfortunately, Motto only works in {browser}. Please switch apps and head to motto.io
					<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			},
			"safari_inapp": {
				"text": `
					<br><span style=\"; font-size:2.2em\">M O T T O</span>
					<br>__________________<br><br>
					Hi! Motto is an experience designed for your browser. To continue, please open {browser} and type in: motto.io
					<br><br>
				`,
				"textSize": "1.0em",
				"textType": "center",
				"type": "montage-mirror",
				"params": {
					"montage": ["videos/water/*"], 
					"videoDuration": 2.0,
					"videoSpeed": 0.7
				},
				"noMenu": true
			}
		},

		//EN: messages de camera
		"camera": {
			"refusedReload": `
				Sorry, you won&#39;t be able to continue with MOTTO unless you grant it access to the camera. We won&#39;t submit your videos without permission, and no audio will ever be recorded.<br><br>
				<a href=\"#\" id=\"page-reload\">Reload the page to continue</a>
			`,
			"refusedIos":`
				To continue, you need to let MOTTO access your camera. Either you really don&#39;t want to continue with this project or else the camera is turned off in your {browser} settings. To fix this, go to Settings &gt; {browser} &gt; Camera &amp; Microphone Access and turn it ON.<br><br>
				<a href=\"#\" id=\"page-reload\">Then reload the page</a>
			`,
			"refusedAndroid":`
				To continue, you need to let MOTTO access your camera by editing Chrome&#39;s site settings for this page. Do this by tapping the lock icon at the top of this page, choosing Site Settings, and allowing Access to Camera. We won&#39;t submit your videos without permission, and no audio will ever be recorded.<br><br>
				<a href=\"#\" id=\"page-reload\">Then reload the page</a>
			`,
			"refusedOthers":`
				To continue, you need to let MOTTO access your camera. Either you really don&#39;t want to continue with this project or else the camera is turned off in your browser's settings. To fix this, go to Settings &gt; Camera &amp; Microphone Access and turn it ON. We won&#39;t submit your videos without permission, and no audio will ever be recorded.</br><br>
				<a href=\"#\" id=\"page-reload\">Then reload the page</a>
			`,
			"working": "Great, the camera&#39;s working!"
		},

		//EN: views
		"views": {
			"welcomeBack": {
				"text": `
					<a id=\"link_continue_now\"><br>
					&nbsp;&nbsp;Welcome back&nbsp;&nbsp;<br>
					to Motto!</span>
					<br><br>Continue where<br>you left off.<br><br></a>
				`,
				"textType": "center",
				"textSize": "1.1em",
				"type": "montage",
				"isWelcomeBack": true,
				"params": {
					"montage": ["videos/bookmark/book_close.mov"],
					"palindrome": true, 
					"reverse": true,
					"videoDuration": 3.0,
					"videoSpeed": 1.0
				},
				"background": "white"
			},
			"continueLater": `
				<br></span>We&#39;ve saved your place and you can finish another time. Also, you can add this page to your home screen if you wish. See you soon!
				<span style=\"font-size:0.6em\"><br><br>(If your browser is in Private mode,<br>you need to keep this page open or<br>we&#39;ll lose your spot.)</span><br><br>
			`,
			"continueLaterReturnCovid": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Next chapter</a><br><br>
			`,
			"continueLaterReturnGhost5": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Conclude Now</a><br><br>
			`,
			"continueLaterReturn4": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Continue<br>Inside<br>a Ghost</a><br><br>
			`,
			"continueLaterReturn": `
				<br><span style=\"; font-size:0.6em\">M O T T O
				<br><br>__________________</span><br><br>
				<a id=\"link_in_next\">Continue<br>Inside</a><br><br>
				<span style=\"color:777777; font-size:0.6em\">-</span><br><br>
				<a id=\"link_out_next\">Continue<br>Outside</a><br><br>
			`,
			"continueLaterMontage":{
				"montage": ["videos/bookmark/book_open.mov"],
				"palindrome": true, 
				"reverse": true,
				"videoDuration": 3.0,
				"videoSpeed": 0.8
			},
			"allowCameraFirst": {
				"text": `<span>By clicking \"Allow\" you agree<br>to let Motto use the videos<br>you submit in the project.<br>No audio will be recorded<br>and we won't give these<br>videos to anyone else.</span>`,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraChapter": {
				"text": `We have to authorize your camera again for the chapter.`,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraReturn": {
				"text": `Welcome back to Motto!<br>Click \"Allow\" to be able to keep using your camera. We still won't ever record any audio.`,
				"isAutomaticReturn": true,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			},
			"allowCameraReturnNoWelcomeBack": {
				"text": `Click \"Allow\" to be able to keep using your camera. We still won't ever record any audio.`,
				"isAutomaticReturn": true,
				"textType": "top",
				"type": "allowcamera",
				"params": {},
				"background": "white"
			}
		},


		//
		// EN: Les textes de page
		//
		"pages": {
			"about-title": "About Motto",
			"share-title": "Share Motto",
			"credits-title": "Credits",
			"about": `
				<div class="about-credits">
					Directed by <a target="_BLANK" href="https://vincentmorisset.com/" class="about-name-link"><b>Vincent Morisset</b></a><br>
					Written by <a target="_BLANK" href="http://byseanmichaels.com/" class="about-name-link"><b>Sean Michaels</b></a><br>
					Coded by <a target="_BLANK" href="https://edouardlb.com/" class="about-name-link"><b>Édouard Lanctôt-Benoit</b></a><br>
					Edited by <a target="_BLANK" href="https://caroline-robert.com/" class="about-name-link"><b>Caroline Robert</b></a><br>
					Created by the studio <a target="_BLANK" href="http://aatoaa.com/" class="about-name-link"><b>AATOAA</b></a><br>
					Produced by <a target="_BLANK" href="https://nfb.ca/" class="about-name-link"><b>the National Film Board of Canada</b></a><br><br>
					<a target="_BLANK" class="about-link" onclick="if (window.MenuController) {window.MenuController.openCredits();}">Full credits</a><br>
				</div>
				<br>
				<div class="text-spacer-line"></div>
				<br>
				Motto is a playful, one-of-a-kind adventure—an interactive novella that uses thousands of tiny videos to tell the thousand-year tale of a kindhearted spirit named September. Part ghost story, part scavenger hunt, Motto finds a way to be both documentary and fiction—incorporating participants’ lo-fi, unstaged footage into its own emotional narrative. It’s like a mirror ball that refracts its audience’s imaginations, rearranging the way they look at the world.<br><br>Conceived for your mobile device, small enough to fit in your pocket, Motto combines new technologies with some of our oldest. Text, image, algorithm and computer vision intermingle as a nameless narrator leads the participant from today to yesterday to a possible tomorrow, from the Québécois countryside to the Chilean desert to the chattering banks of the Nile. September has gone missing: Where has this ghost disappeared to? What can we learn on our quest? Meditating on memory, metaphor and the power of creativity—and calling upon each of its users’ senses—Motto gives birth to its own fascinating, intimate universe, where you will never guess what happens next.<br><br>Motto is an original collaboration between AATOAA, Vincent Morisset’s acclaimed digital production studio, and prize-winning novelist Sean Michaels. This is the third collaboration between the National Film Board of Canada and Vincent Morisset, after the Webby Award winners BLA BLA (2011) and Way to Go (2015). With this project they are exploring a new, intuitive storytelling vocabulary, inviting audiences to fold their own memories into the way a tale is told, and drawing on influences as diverse as Agnès Varda, Snapchat, Italo Calvino, Christian Marclay, W. G. Sebald, Bruno Munari and Being John Malkovich.<br>
				<br>
				<div class="text-spacer-line"></div>
				<br>
				<a target="_BLANK" class="about-link" href="https://mediaspace.nfb.ca/epk/motto/">Link to the press kit</a><br>
				<br>
				<div class="text-spacer-line"></div>
				<br>
				<b>Legal notices</b><br><br>
				Motto uses “cookies” to enable certain functionalities during the experience. Cookies are small text files that are stored on your device when you visit certain websites. Because Motto is comprised of six chapters, you may not complete the entire experience in one visit. Cookies allow you to enjoy Motto over several sessions without losing your progress. They also save your video contributions so that these will reappear as the experience goes on. Note that no personal data is collected at any time during the experience. Furthermore, if you do not want the NFB to install a cookie on your device, you can disable the storage of cookies in your browser. In this case, your progress in Motto will not be saved, and you will lose all contributions you have made as soon as you close the Motto window in your web browser.<br><br>
				Motto uses thousands of short user-generated videos. When you authorize Motto to access your camera, you grant the NFB the right to use the images that you capture during the experience. These images will be used exclusively as part of the Motto project and for promotional and rollout purposes.<br>
			`,
			"credits": `
				Created by the studio <a target="_BLANK" href="http://aatoaa.com/" class="about-name-link"><b>AATOAA</b></a><br>
				<br>
				Produced by <a target="_BLANK" href="https://nfb.ca" class="about-name-link"><b>the National Film Board of Canada</b></a><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Directed by<br>
				<a target="_BLANK" href="https://vincentmorisset.com/" class="about-name-link"><b>Vincent Morisset</b></a><br>
				<br>
				Written by<br>
				<a target="_BLANK" href="http://byseanmichaels.com/" class="about-name-link"><b>Sean Michaels</b></a><br>
				<br>
				Coded by<br>
				<a target="_BLANK" href="https://edouardlb.com/" class="about-name-link"><b>Édouard Lanctôt-Benoit</b></a><br>
				<br>
				Edited by<br>
				<a target="_BLANK" href="https://caroline-robert.com/" class="about-name-link"><b>Caroline Robert</b></a><br>
				<br>
				Shootings<br>
				<b>Caroline Robert & Vincent Morisset</b><br><br>
				<div class="credits-spacer-small"></div>
				<br>
				National Film Board of Canada:<br><br>
				Producer<br>
				<b>Marie-Pier Gauthier</b><br>
				<br>
				Executive Producers<br>
				<b>Louis-Richard Tremblay</b><br>
				<b>Hugues Sweeney</b><br>
				<br>
				Production Manager<br>
				<b>Marie-Eve Babineau</b><br>
				<br>
				Technology Director<br>
				<b>Martin Viau</b><br>
				<br>
				Editorial Managers<br>
				<b>Valérie Darveau</b><br>
				<b>Laurence Dolbec</b><br>
				<br>
				Senior Production Coordinator<br>
				<b>Léa Graziella Formigli</b><br>
				<br>
				Interactive Media Coordinator<br>
				<b>Caroline Fournier</b><br>
				<br>
				Administrator<br>
				<b>Marie-Andrée Bonneau</b><br>
				<br>
				Senior Administrative Coordinator<br>
				<b>Claudia Boutin</b><br>
				<br>
				Production coordinator<br>
				<b>Dominique Brunet</b><br>
				<br>
				Information Technology<br>
				<b>Sergiu Suciu</b><br>
				<br>
				Marketing Manager<br>
				<b>Laurianne Desormiers</b> <br>
				<br>
				Marketing Coordinator<br>
				<b>Stéphanie Quevillon</b><br>
				<br>
				Social Media Strategists<br>
				<b>Emilie Nguyen Ngoc</b><br>
				<b>Hannah Martin</b><br>
				<br>
				Community Managers <br>
				<b>Alyssia Duval-Nguon</b><br>
				<b>Melissa Sauvé</b><br>
				<br>
				Press Relations<br>
				<b>Nadine Viau</b><br>
				<b>Jennifer Mair</b><br>
				<br>
				Legal Services<br>
				<b>Christian Pitchen</b><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Collaborators:<br><br>
				Fixer (Chili)<br>
				<b>Pablo Esquer</b><br>
				<br>
				Research<br>
				<b>Fadwa Lapierre</b><br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				Archive Footage:<br><br>
				<b>Aaron Morris<br>
				Albert Courtemanche &  Bibliothèque et Archives nationales du Québec<br>
				Apollo missions, NASA<br>
				Caroline Robert & Vincent Morisset<br>
				Conrad Poirier & Bibliothèque et Archives nationales du Québec<br>
				Justin Bilton via Storyful<br>
				Metropolitan Museum of Art<br>
				Wikimedia Commons</b><br>
				<br>
				<br>
				<div class="credits-spacer-small"></div>
				<br>
				First contributions:<br><br>
				<b>Aaron Varquero<br>
				Aimée Kassi<br>
				Alexe Louisa<br>
				Angel Carpio<br>
				Anne-Marie Lavigne<br>
				Astrid Feringa<br>
				Aymane Sahrane<br>
				Benedicte Kurzen<br>
				Camille Foisy<br>
				Carl Ruttan<br>
				Chilandre Patry<br>
				Deborah Chèrenfant<br>
				Diana Aziz<br>
				Diderik Evers<br>
				Dorothy Alexandre<br>
				Éricka Alnéus<br>
				Erwin Verbruggen<br>
				Eva van Dijk<br>
				Ewelyn Wnek<br>
				Fanny Robert<br>
				Francois Turcotte<br>
				Gígja Reynisdóttir<br>
				Greta Petronio<br>
				Guillaume Lee-Millier<br>
				Hamza Abouelouafaa<br>
				Harm Croockewit<br>
				Inge Bongers<br>
				Israel Hernandez Ruiz Velasco<br>
				Jean-Michel Portail<br>
				Jean-Philippe Côté<br>
				Jessie Dorélien<br>
				Jessy Thermil<br>
				JF Nadeau<br>
				Jorge Camarotti<br>
				Jumoke Sanwo<br>
				Kevin Plasman<br>
				Leisa Lee<br>
				Lily Tremblay-Viau<br>
				Lyne Godin<br>
				Marianne Bourdages<br>
				Marisol de Santis<br>
				Matteo Frescobaldi<br>
				Nancy Thibodeau<br>
				Nicholas Klassen<br>
				Nicolas Ouellet<br>
				Nizar Lachqar<br>
				Pascale Daigle<br>
				Pascale Tetrault<br>
				Perry-Delphine Séraphin<br>
				Peter Antoine<br>
				PM Fortin<br>
				Quirine Racké<br>
				Rachid Sahrane<br>
				Rafaella Wang<br>
				Ravenne Portail<br>
				Rosalie Léonard<br>
				Sabrina Lachqar<br>
				Samantha Pietro<br>
				Sanne De Wilde<br>
				Sarah Spring<br>
				Sophia Jasmin<br>
				Sophie Robert<br>
				Soumia Sahrane<br>
				Stephane Buellet<br>
				Stephane Lafleur<br>
				Stevens Charles<br>
				Tawan Arun<br>
				Tracy Maurice<br>
				Yazmin Solorzano<br>
				Ying Gao</b><br><br>
				<div class="credits-spacer-small"></div>
				<br>
				Special thanks:<br><br>
				<b>Andrea Costabal<br>
				Arlen & Jan Michaels<br>
				Canadian Museum of Nature<br>
				Casadel Films<br>
				Caspar Sonnen<br>
				Catherine Emmanuel Brunet<br>
				Claudette Raymond<br>
				Daniela Ábrigo<br>
				Emily Wood<br>
				Gabi<br>
				IDFA Doclab<br>
				Jessie Van Vreden<br>
				Lily Jeanne Babineau<br>
				Marcela Cavallaro<br>
				Marisol Bacunan<br>
				Martin Babineau<br>
				Québec's public daycare system<br>
				Neues Museum<br>
				Raul Titerman<br>
				Rolando Santana<br>
				Sandro Perri<br>
				Sylvain Mazas<br>
				Thea Metcalfe & Miro<br>
				The Morisset family<br>
				The Pereda family<br>
				The Robert family<br>
				Thierry Sirois</b><br><br>
			`,
			"share": `
				<div class="share-large">
					<div class="share-btn" id="share-facebook">
						<div id="facebook-logo"></div>
						<div class="share-text">Facebook</div>
					</div>
				</div>
				<div class="share-large">
					<div class="share-btn" id="share-twitter">
						<div id="twitter-logo"></div>
						<div class="share-text">Twitter</div>
					</div>
				</div>
				<div class="share-large" id="share-link-container">
					<div class="share-btn" id="share-btn-link">
						<div id="sharelink-logo" id="share-link"></div>
						<div class="share-text">Copy Link</div>
					</div>
				</div>
			`
		}
	}
}
